


































































































































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { checkPermissions } from '@/directives/permissionDirective'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import moment from 'moment'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ReportShare from './ReportShare.vue'

@Component({
    components: {
        ConfirmDialog,
        ReportShare
    }
})
export default class ReportList extends Vue {
    @Prop() loading!: boolean
    @Prop() selectRows!: boolean
    @Prop() customColums!: ADMColumn[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() selectedRows!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() columns!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() dataRows!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() dataFavorite!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() pagination!: any
    @Prop() rowsPerPage!: number
    @Prop() sortBy!: string
    @Prop() sortByDesc!: boolean

    permissionPrefix = 'report'
    confirmDialogTrigger = false
    confirmDialogClone = false
    confirmDialogFavorite = false
    confirmDialogShare = false
    confirmDialogData = null

    listSortDesc = false
    listSortBy = ''

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkExistFavorite (item: any) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const fav = this.dataFavorite.find((x: any) => x.reportId.reportId === item.reportId)
        if (fav) {
            return true
        } else {
            return false
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkOwner (item: any, reportPrivate?: boolean) {
        const userId = this.$store.state.AuthStore.auth.user.userId
        if (reportPrivate) {
            if ((item.reportPrivateEnabled === 1 && (item.userId.userId === userId || userId === 1))) {
                return true
            } else {
                return false
            }
        } else {
            if (item.userId.userId === userId || userId === 1) {
                return true
            } else {
                return false
            }
        }
    }

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    @Watch('pagination', { deep: true })
    paginationHandler () {
        this.$emit('paginationTable', this.pagination.currentPage)
    }

    mounted () {
        this.listSortBy = this.sortBy
        this.listSortDesc = this.sortByDesc
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateSortBy (item: any) {
        this.listSortBy = item || ''
        if (this.listSortBy === '') return
        this.$emit('loadData', { sortBy: this.listSortBy, sortByDesc: this.listSortDesc })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateSort (item: any) {
        if (this.listSortDesc === !!item) return
        this.listSortDesc = !!item
        this.$emit('loadData', { sortBy: this.listSortBy, sortByDesc: this.listSortDesc })
    }

    newLimitHandler (val: number) {
        this.$emit('newLimitHandler', val)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchVariableWithArray (variable: string, inputAttibute: string, outputAttibute: string, array: any[], output?: any[]): void|string|number {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const match: any = array.find(item => item[inputAttibute] === variable)
        if (output) output.push(match)
        if (!output) return match ? match[outputAttibute] : '-'
    }

    getDate (dateString: string) {
        return moment(dateString).format('MM/YYYY').toString()
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reportAgend (item: any) {
        this.$emit('reportAgend', item)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (item: any) {
        this.$emit('editField', item)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addRolesField (item: any) {
        this.$emit('addRolesField', item)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    viewReport (item: any) {
        this.$emit('viewReport', item)
    }

    confirmedDialog (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('deleteReports', callback.reportId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                }
            })
    }

    confirmedDialogClone (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('cloneReports', callback.reportId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                }
            })
    }

    confirmedDialogFavorite (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('createReportFavorites', { reportId: callback.reportId, userId: this.$store.state.AuthStore.auth.user.userId })
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadDataFavorite')
                }
            })
    }

    confirmedDialogShare (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('createReportShares', { reportId: callback.reportId, users: callback.users })
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.confirmDialogShare = false
                    this.confirmDialogData = null
                }
            })
    }
}
